<template>
  <div>
    <vue-headful :title="titleLabel" />

    <v-layout row wrap>
      <v-flex xs12>
        <StepTitle>{{titleLabel}}</StepTitle>
      </v-flex>
    </v-layout>

    <ScheduleForm
      ref="date"
      :model="dateComponentData"
      @submit="submit"
      @save="save" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import ScheduleForm from '@/components/forms/ScheduleForm.vue';
import StepTitle from '@/components/StepTitle.vue';
import RouteNameConstants from '@/router/constants/route-names';
import StepUtilities from '@/router/utilities/step-utilities';

export default {
  components: {
    ScheduleForm,
    StepTitle,
  },
  computed: {
    ...mapGetters('Company', ['blockAppointmentsEnabled']),
    ...mapState('Appointment', ['dateComponentData']),
    titleLabel() {
      return this.blockAppointmentsEnabled
        ? 'Schedule an Appointment'
        : 'Request an Appointment';
    },
  },
  methods: {
    save(data) {
      return this.$store.dispatch('Appointment/setDate', data);
    },
    async submit(data) {
      await this.save(data);
      StepUtilities.goToNextStep(this.$route, this.$router);
    },
  },
  mounted() {
    this.$store.commit('setStepIndex',
      StepUtilities.getStepIndexByRouteName(RouteNameConstants.AppointmentSchedule));
  },
};
</script>
